// @flow strict

import React from 'react';
import { Grid } from '@material-ui/core';
import { graphql } from 'gatsby';

import { Layout } from '~components/layout/layout';
import { AuthorListItem } from '~components/author/author-list-item';
import { NewsletterSignup } from '~components/newsletter-signup/newsletter-signup';
import { Sidebar } from '~components/sidebar/sidebar';

import { useLanguageContext } from '~contexts/language-context';

import type { Author } from '~types/author';
import type { Alternates } from '~types/post';

import { withApp } from '../app';

/**
 * Type of component properties
 */
type AuthorsPageProps = {
  data: {
    allAuthorJson: {
      nodes: Array<Author>,
    },
  },

  pageContext: {
    alternates: Alternates,
  },
};

/**
 * Template for authors page.
 *
 * @param {AuthorsPageProps} props - component properties
 *
 * @returns {Node}
 */
const AuthorsPage = ({ data, pageContext }: AuthorsPageProps) => {
  const authors = data.allAuthorJson.nodes;

  const { loc } = useLanguageContext();

  const seoFields = {
    title: loc('_authors_title'),
    description: loc('_authors_description'),
    alternates: pageContext.alternates,
    meta: [
      {
        name: 'robots',
        content: 'noindex, nofollow',
      },
    ],
  };

  return (
    <Layout seoFields={seoFields} alternates={pageContext.alternates}>
      <section className="container">
        <Grid container justifyContent="flex-end" spacing={6}>
          <Grid item md={10}>
            <Sidebar />
            <div>
              {authors.map((author) => {
                return (
                  <AuthorListItem
                    key={author.id}
                    author={author}
                    displayReadAllLink={true}
                  />
                );
              })}
            </div>
          </Grid>
        </Grid>
      </section>

      <div className="container">
        <NewsletterSignup />
      </div>
    </Layout>
  );
};

export default withApp(AuthorsPage);

// noinspection JSUnusedGlobalSymbols
export const pageQuery = graphql`
  query {
    allAuthorJson {
      nodes {
        ...Author
      }
    }
  }
`;
